/* eslint-disable-next-line */
export interface WebHullaSectionProps {}

export function WebHullaSection(props: WebHullaSectionProps) {
  return (
    <div>
      <h1>Welcome to WebPlaHullaSection!</h1>
    </div>
  );
}

export default WebHullaSection;
